import { configureStore } from '@reduxjs/toolkit';
import galleryReducer from "../Reducers/galleryReducer"
import cartReducer from "../Reducers/cartReducer"
import documentsReducer from "../Reducers/documentsReducer"
import userReducer from "../Reducers/userReducer"
import channelReducer from "../Reducers/channelReducer"

const store = configureStore({
    reducer: {
        gallery: galleryReducer,
        cart: cartReducer,
        documents: documentsReducer,
        user: userReducer,
        channel: channelReducer
    }
});

export default store;